import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import classes from './PrepareConsultation.module.css';
import { fetchConsultationFindings } from '../../store/slices/consultationFindings';
import { fetchConsultationInvestigations } from '../../store/slices/consultationInvestigations';
import { fetchConsultationRecommendations } from '../../store/slices/consultationRecommendations';
import { fetchSalesOrders } from '../../store/slices/salesOrders';
import {
  resetUpdateStatus,
  selectConsultationStatusUpdateStatus,
} from '../../store/slices/workOrderServiceConsultation';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { fetchConsultationNotes } from '../../store/slices/consultationNotes';
import { fetchVitalSigns } from '../../store/slices/vitalSigns';
import { selectUserRole } from '../../store/slices/auth';
import { NURSE_USER_ROLE } from '../../constants/userRolesConstants';
import { ConsultationTypes } from '../../enums/enums';

const PrepareConsultation: React.FC<any> = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [pageInfo] = useState<any>(location.state);
  const userRole: string = useAppSelector<string>(selectUserRole);
  const [workOrderStatusId] = useState<number>(pageInfo?.work_order?.work_order_status_id ?? 1);
  const consultationStatusUpdateStatus: string = useAppSelector<string>(
    selectConsultationStatusUpdateStatus
  );

  useEffect(() => {
    if (!pageInfo?.sales_order) {
      navigate('/web/consultations/upcoming', { replace: true });
    }
    dispatch(fetchSalesOrders());
    dispatch(fetchConsultationFindings());
    dispatch(fetchConsultationNotes());
    dispatch(fetchConsultationInvestigations());
    dispatch(fetchConsultationRecommendations());
    dispatch(fetchVitalSigns());
  }, [dispatch]);

  useEffect(() => {
    if (consultationStatusUpdateStatus === 'fulfilled') {
      dispatch(resetUpdateStatus());
      if (workOrderStatusId === 6) {
        if (
          userRole === NURSE_USER_ROLE &&
          (pageInfo?.service_service_group.service_group_id !==
            ConsultationTypes.FACE_TO_FACE_CONSULTATION ||
            pageInfo?.service_service_group?.service_group_id !==
              ConsultationTypes.REVIEW_CONSULTATION)
        ) {
          if (pageInfo?.service_service_group.service_group_id === 7)
            navigate('/web/prejoin-consultation', {
              state: {
                ...pageInfo,
              },
            });
          return;
        }
        if (
          pageInfo?.service_service_group.service_group_id ===
            ConsultationTypes.FACE_TO_FACE_CONSULTATION ||
          pageInfo?.service_service_group.service_group_id === ConsultationTypes.REVIEW_CONSULTATION
        ) {
          navigate('/web/facetoface-consulting-room', {
            state: {
              ...pageInfo,
            },
          });
        } else {
          navigate('/web/video-consulting-room', {
            state: {
              ...pageInfo,
            },
          });
        }
      }
    }
    if (consultationStatusUpdateStatus === 'rejected') {
      dispatch(resetUpdateStatus());
    }
  }, [consultationStatusUpdateStatus, dispatch]);

  return (
    <div className={`${classes.container} ${classes.containerWithDetails}`}>
      <div
        className={classes.menuContainer}
        style={{
          flex: 1,
        }}
      >
        {/* <VideoMenu
          handleClose={() => { }}
          findingText={findingsText}
          findingId={finding?.consultation_findings_id ?? 0}
          recommendationText={recommendationText}
          recommendationId={recommendation?.consultation_recommendations_id ?? 0}
          internalNoteText={internalNotesText}
          internalNoteId={internalNotes?.consultation_notes_id ?? 0}
          variant="full"
          isOpenInPrepare={true}
          workOrderStatusId={workOrderStatusId}
          actionButton={
            <PrimaryButtonV2
              text={
                accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION &&
                  workOrderStatusId == 1
                  ? translations('consultation.prepared')
                  : pageInfo?.service_service_group?.service_group_id === 8
                    ? translations('start.consultation')
                    : translations('start.video.consultation')
              }
              containerStyle={{}}
              buttonStyle={{
                height: '46px',
                width: '240px',
              }}
              disabled={
                userRole === NURSE_USER_ROLE &&
                  accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION &&
                  workOrderStatusId == 1
                  ? false
                  : userRole === NURSE_USER_ROLE &&
                  pageInfo?.service_service_group.service_group_id !== 7
              }
              onClick={() => {
                // set consultation to prepared status
                if (
                  accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION &&
                  workOrderStatusId == 1
                ) {
                  dispatch(
                    updateStatusOfConsultation({
                      workOrderId: pageInfo?.work_order?.work_order_id ?? 0,
                      workOrderStatusId: 5,
                      details: {},
                      taId: pageInfo?.sales_order.ta_id,
                      transactionId: pageInfo?.sales_order.transaction_id,
                      personEmail: pageInfo?.person.person_email,
                      personAccountNumber: pageInfo?.person.person_account_number,
                    })
                  );
                  setWorkOrderStatusId(5);
                  return;
                }
                if (accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION) {
                  dispatch(
                    updateStatusOfConsultation({
                      workOrderId: pageInfo?.work_order?.work_order_id ?? 0,
                      workOrderStatusId: 6,
                      details: {},
                      taId: pageInfo?.sales_order.ta_id,
                      transactionId: pageInfo?.sales_order.transaction_id,
                      personEmail: pageInfo?.person.person_email,
                      personAccountNumber: pageInfo?.person.person_account_number,
                    })
                  );
                  setWorkOrderStatusId(6);
                  return;
                }
                if (userRole === NURSE_USER_ROLE) {
                  if (pageInfo?.service_service_group.service_group_id === 7)
                    navigate('/web/prejoin-consultation', {
                      state: {
                        ...pageInfo,
                      },
                    });
                  return;
                }
                if (pageInfo?.service_service_group.service_group_id === 8) {
                  navigate('/web/facetoface-consulting-room', {
                    state: {
                      ...pageInfo,
                    },
                  });
                } else {
                  navigate('/web/video-consulting-room', {
                    state: {
                      ...pageInfo,
                    },
                  });
                }
              }}
            />
          }
        /> */}
      </div>
    </div>
  );
};

export default PrepareConsultation;
